import find from "lodash/find";

import {Part} from "./part";
import {ceilingThumbnail, ceilingPlaceholder} from "../assets";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {IntermediatePart} from "./intermediatePart";

export class Ceiling extends Part {
  static id = 'Ceiling';

  constructor() {
    super(true, false, PartMenuType.Simple);
    this.partId = 'ceiling';
    this.menuType = PartMenuType.Simple;
    this.partName = 'Ceiling';
    this.translateId = "visualizer.bathroom.ceiling";
    this.homePageTitle = 'Ceilings';
    this.partThumbnail = ceilingThumbnail;
    this.ceilingLight = null;
  }

  load(dbFeature) {
    let part = null;
    switch (dbFeature.groupName) {
      case "Ceiling":
        part = new CeilingBody();
        break;
      case "Ceiling Lights":
        if (!this.ceilingLight) {
          this.ceilingLight = new CeilingLight(true);
          this.relatedItems.push(this.ceilingLight);
        }
        part = this.ceilingLight;
        break;
    }
    if (part) {
      part.getParent = () => this;
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      part.load(dbFeature);
      return true
    }
    return false
  }

  setLayers(layout, placeholdersNeeded) {
    const layers = [];

    if (placeholdersNeeded && !this.placeholderChanged && this.placeholderFeature) {
      this.placeholderFeature.layer.src = ceilingPlaceholder;
      this.placeholderFeature.layer.fromS3 = false;
      this.placeholderFeature.layer.addTo(layers)
    } else if (this.activeFeature) {
      this.activeFeature.setLayers(layout);
      this.activeFeature.layer.addTo(layers);
    }

    this.relatedItems.forEach(relatedItem => {
      relatedItem.setLayers(layout);
      if (relatedItem && relatedItem.activeFeature) {
        relatedItem.activeFeature.layer.addTo(layers);
      }
    });

    return layers;
  }

  setDefault(layout) {
    this.relatedItems.forEach(_ => _.setDefault(layout));
    const hardCodedDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("BR Frost");
    });
    const placeholderDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
    });
    this.activeFeature = hardCodedDefault || this.features[0];
    this.placeholderFeature = placeholderDefault || this.features[0];
  }

  navigationItem() {
    return new DesignNavigationItem(this.partName, this);
  }

  handleSubPartClick() {}

  setZIndex(zIndexes) {
    if(zIndexes) {
      this.relatedItems.forEach(_ => _.setZIndex(zIndexes));
      this.activeFeature && this.activeFeature.setZIndex(zIndexes);
      if(this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Ceiling;
      }
    }
  }

  subParts() {
    return [{
      text: this.partName,
      part: this
    }]
  }
}

class CeilingBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);

    this.partName = 'Ceiling';
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    super.load_.call(this.getParent(), dbFeature, this, false);
  }

  setLayers(layout) {
    // const s3Binding = find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this)});
    let s3Binding = find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this), layout: layout.getCurrentLayoutAbbreviation()});
    if (!s3Binding) {
      s3Binding =  find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this)});
    }
    this.layer.fromS3Binding(s3Binding);
  }

  setDefault(layout) {
    this.activeFeature = super.setDefault(layout) || this.features[0];
  }

  setZIndex(zIndexes) {
    if(zIndexes)
      this.layer.zIndex = zIndexes.Ceiling;
  }
}

class CeilingLight extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partName = 'Ceiling Light';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new CeilingLight());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature && this.activeFeature.layer) {
      this.activeFeature.layer.zIndex = zIndexes.Ceiling_Lights;
    }
  }
}

